import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionService { 
  
  private data: any = {};

  constructor() { }

  set(key: string, value: any) {
    // sessionStorage.setItem(key, value);
    this.data[key] = value;
  }

  get(key: string, defaultValue = null) {
    // return this.has(key) ? sessionStorage.getItem(key) : defaultValue;
    return this.data[key] !== undefined ? this.data[key] : defaultValue;
  }

  remove(key: string) {
    delete this.data[key];
  }

  has(key: string) {
    return this.data[key] !== undefined;
  }

}
